export const UNSUBSCRIBE_FROM_EMAILS =
  'jora-employer/unsubscribe/UNSUBSCRIBE_FROM_EMAILS';

export const GET_EMAIL_PREFERENCE_CENTER_URL =
  'jora-employer/unsubscribe/GET_EMAIL_PREFERENCE_CENTER_URL';
export const GET_EMAIL_PREFERENCE_CENTER_URL_SUCCESS =
  'jora-employer/unsubscribe/GET_EMAIL_PREFERENCE_CENTER_URL_SUCCESS';
export const GET_EMAIL_PREFERENCE_CENTER_URL_FAIL =
  'jora-employer/unsubscribe/GET_EMAIL_PREFERENCE_CENTER_URL_FAIL';
